// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3BIx3","dragIcon":"Choice_dragIcon__2R0IW","left":"Choice_left__3rbKp","input":"Choice_input__xrV-T"};